import config from '../../../config';

const sheAdTargetMap = {
  camID: 'pub_meta_1',
  areaID: 'pub_meta_2',
  regionID: 'pub_meta_3',
  subregionID: 'pub_meta_4',
  sst: 'pub_meta_5',
  usertype: 'pub_meta_6',
  contentCategoryId: 'pub_meta_7',
  contentSeriesId: 'pub_meta_8',
  contentTagId: 'pub_meta_9',
  viewType: 'pub_meta_10',
  contentKeyword: 'ci',
};

const mapAdTargets = (adTargets, userType, viewType) => {
  if (!config.useSheMedia) return [...adTargets, ['usertype', userType]];
  const mappedAdTargets = adTargets.map((target) => {
    const [key, value] = target;
    // eslint-disable-next-line
    const targetKey = sheAdTargetMap.hasOwnProperty(key) ? sheAdTargetMap[key] : key;
    return [targetKey, value];
  });
  return [
    ...mappedAdTargets,
    [sheAdTargetMap.usertype, userType],
    [sheAdTargetMap.viewType, viewType],
  ];
};

const usertype = (userDetails, userEntitlements) => {
  if (!userDetails) return 'ANONYMOUS';
  if (userEntitlements.includes('sl_vip_advertiser')) return 'VIP_ADVERTISER';
  if (userEntitlements.includes('sl_vip')) return 'VIP';
  if (userEntitlements.includes('sl_premium')) return 'PREMIUM';
  return 'REGISTERED';
};

const getAdTargets = (qaFlag, user, entitlements, contentKeyword) => {
  const adTargets = [
    ['position', 'SPONSORSHIP'],
    ['qaFlag', qaFlag],
    ['usertype', usertype(user, entitlements)],
  ];
  if (contentKeyword) adTargets.push(['contentKeyword', contentKeyword]);
  return mapAdTargets(adTargets);
};

const defaultAdSizeMappings = [
  [
    [1200, 0],
    ['fluid', [1170, 250], [1170, 160], [990, 90], [970, 250], [970, 160], [970, 90], [728, 90]],
  ],
  [
    [992, 0],
    ['fluid', [990, 90], [970, 250], [970, 160], [970, 90], [750, 250], [728, 90]],
  ],
  [
    [768, 0],
    ['fluid', [750, 250], [750, 160], [728, 90]],
  ],
  [
    [320, 0],
    ['fluid', [320, 80], [320, 50]],
  ],
  [
    [0, 0],
    ['fluid', [320, 50]],
  ],
];

const defaultAdSizeMappingsSHE = [
  [[992, 0], 'flexbanner'],
  [[768, 0], 'banner'],
  [[0, 0], 'tinybanner'],
];

const editorialHeroAdSizes = {
  adUnit: 'Horizontal_Variable',
  adId: 'Horizontal_Variable',
  adSizeMappings: defaultAdSizeMappings,
  adSizeMappingsSHE: defaultAdSizeMappingsSHE,
  additionalMappingSizes: [
    ['flexbanner', [[1170, 250]]],
    ['banner', [[750, 250]]],
    ['tinybanner', [[320, 80]]],
  ],
  collapseEmpty: true,
};

export const heroAdConfigMap = {
  homepage: {
    adUnit: 'HP_Horizontal_Variable',
    adId: 'HP_Horizontal_Variable',
    adViewType: 'HOMEPAGE',
    adSizeMappings: defaultAdSizeMappings,
    adSizeMappingsSHE: defaultAdSizeMappingsSHE,
    additionalMappingSizes: [
      ['flexbanner', [[1170, 250]]],
      ['banner', [[750, 250]]],
      ['tinybanner', [[320, 80]]],
    ],
    collapseEmpty: true,
  },
  contest_sos: {
    adViewType: 'CONTEST',
    adUnit: 'SL_Cuervo_Horizontal_Variable',
    adId: 'SL_Cuervo_Horizontal_Variable',
    adSizeMappings: defaultAdSizeMappings,
    adSizeMappingsSHE: defaultAdSizeMappingsSHE,
    additionalMappingSizes: [
      ['flexbanner', [[1170, 250]]],
      ['banner', [[750, 250]]],
      ['tinybanner', [[320, 80]]],
    ],
    collapseEmpty: true,
  },
  wotw_2021: {
    adViewType: 'CONTEST',
    adUnit: 'SL_WOTW_Horizontal_Variable_21',
    adId: 'SL_WOTW_Horizontal_Variable_21',
    adSizeMappings: defaultAdSizeMappings,
    adSizeMappingsSHE: defaultAdSizeMappingsSHE,
    additionalMappingSizes: [
      ['flexbanner', [[1170, 250]]],
      ['banner', [[750, 250]]],
      ['tinybanner', [[320, 80]]],
    ],
  },
  wotw_regional_2021: {
    adViewType: 'CONTEST',
    adUnit: 'SL_WOTW_Regional_Horizontal_Variable_21',
    adId: 'SL_WOTW_Regional_Horizontal_Variable_21',
    adSizeMappings: defaultAdSizeMappings,
    adSizeMappingsSHE: defaultAdSizeMappingsSHE,
    additionalMappingSizes: [
      ['flexbanner', [[1170, 250]]],
      ['banner', [[750, 250]]],
      ['tinybanner', [[320, 80]]],
    ],
  },
  editorial_article: {
    adViewType: 'CONTENT_ARTICLE',
    collapseEmpty: true,
    ...editorialHeroAdSizes,
  },
  editorial_home: {
    adViewType: 'CONTENT_HOME',
    collapseEmpty: true,
    ...editorialHeroAdSizes,
  },
  editorial_category: {
    adViewType: 'CONTENT_CATEGORY',
    collapseEmpty: true,
    ...editorialHeroAdSizes,
  },
  editorial_tag: {
    adViewType: 'CONTENT_TAG',
    collapseEmpty: true,
    ...editorialHeroAdSizes,
  },
  editorial_series: {
    adViewType: 'CONTENT_SERIES',
    collapseEmpty: true,
    ...editorialHeroAdSizes,
  },
  forecast_article: {
    adUnit: 'SL_Forecast_ExpertContent_HorizontalVariable',
    adId: 'SL_Forecast_ExpertContent_HorizontalVariable',
    adViewType: 'FORECAST_ARTICLE',
    adSizeMappings: defaultAdSizeMappings,
    adSizeMappingsSHE: defaultAdSizeMappingsSHE,
    additionalMappingSizes: [
      ['flexbanner', [[1170, 250]]],
      ['banner', [[750, 250]]],
      ['tinybanner', [[320, 80]]],
    ],
    collapseEmpty: true,
  },
  search_results: {
    adUnit: 'SL_SearchResults',
    adId: 'SL_SearchResults',
    adViewType: 'SEARCH_RESULTS',
    adSizeMappings: defaultAdSizeMappings,
    adSizeMappingsSHE: defaultAdSizeMappingsSHE,
    additionalMappingSizes: [
      ['flexbanner', [[1170, 250]]],
      ['banner', [[750, 250]]],
      ['tinybanner', [[320, 80]]],
    ],
    collapseEmpty: true,
  },
  sessions_clips: {
    adUnit: 'SL_Sessions_Horizontal_Variable',
    adId: 'SL_Sessions_Horizontal_Variable',
    adViewType: 'SESSIONS_CLIPS',
    adSizeMappingsSHE: defaultAdSizeMappingsSHE,
    additionalMappingSizes: [
      ['flexbanner', [[1170, 250]]],
      ['banner', [[750, 250]]],
      ['tinybanner', [[320, 80]]],
    ],
    collapseEmpty: true,
  },
};

const heroAdConfig = (adType, user, entitlements, qaFlag, contentKeyword) => ({
  adUnit: `/1024858/${heroAdConfigMap[adType].adUnit}`,
  adId: heroAdConfigMap[adType].adId,
  adSizes: [
    'fluid',
    [1170, 250],
    [1170, 160],
    [990, 90],
    [970, 250],
    [320, 50],
    [970, 90],
    [970, 160],
    [320, 80],
    [300, 250],
    [750, 250],
    [750, 160],
    [728, 90],
  ],
  adSizeMappings: heroAdConfigMap[adType].adSizeMappings,
  adSizeMappingsSHE: heroAdConfigMap[adType].adSizeMappingsSHE,
  additionalMappingSizes: [
    ['flexbanner', [[1170, 250]]],
    ['banner', [[750, 250]]],
    ['tinybanner', [[320, 80]]],
  ],
  adClass: 'sl-hero-ad-unit__dfp',
  adViewType: heroAdConfigMap[adType].adViewType,
  adTargets: getAdTargets(
    qaFlag,
    user,
    entitlements,
    contentKeyword,
    heroAdConfigMap[adType]?.adViewType,
  ),
  collapseEmpty: true,
});

export default heroAdConfig;
